<list-view [liste]="geographieService.listeTerritoires" *ngIf="geographieService.listeTerritoires"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>